"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var form_1 = require("../../../../context/form");
var props_1 = require("../../../../context/props");
var useIsFilesSizeLimitExceeded = function () {
    var _a = (0, form_1.useFormContext)().files, files = _a === void 0 ? [] : _a;
    var maxFilesSize = (0, props_1.usePropsContext)().maxFilesSize;
    var filesSize = (0, react_1.useMemo)(function () { return files === null || files === void 0 ? void 0 : files.reduce(function (acc, file) { return (acc + file.size); }, 0); }, [files]);
    return filesSize > maxFilesSize;
};
exports.default = useIsFilesSizeLimitExceeded;
